











































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import CategoryExpansionPanel from '@/components/organisms/CategoryExpansionPanel.vue';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import _ from 'lodash';

@Component({
  components: {
    'category-expansion-panel': CategoryExpansionPanel
  }
})
export default class SearchResultViewer extends Vue {
  /** Data **/
  private resultKeywordHeader: any = [
    { text: '', align: 'left', value: 'content_id', order: 0, width: '0%', sortable: false, filterable: false, class: 'hide' },
    { text: '著者', align: 'left', value: 'user_name', order: 3, width: '11%' },
    { text: 'タイトル', align: 'left', value: 'title', order: 1, width: '20%' },
    { text: 'カテゴリ', align: 'left', value: 'category_name', order: 2, width: '21%' },
    { text: '本文', align: 'left', value: 'text_plain', order: 4, width: '32%' },
    { text: '公開日', align: 'left', value: 'published', order: 5, width: '16%' },
    { text: '', align: 'left', value: 'category_type', order: 6, width: '0%', sortable: false, filterable: false, class: 'hide' },
  ];
  private options: {
    page: number
    itemsPerPage: number
    sortBy: string[]
    sortDesc: boolean[]
    groupBy: string[]
    groupDesc: boolean[]
    multiSort: boolean
    mustSort: boolean
  } = {} as {
    page: number
    itemsPerPage: number
    sortBy: string[]
    sortDesc: boolean[]
    groupBy: string[]
    groupDesc: boolean[]
    multiSort: boolean
    mustSort: boolean
  };
  private loading: boolean = true;
  private page: number = 1;
  private numberOfPages: number = 0;
  private itemPerPage: number = 5;
  private total: number = 0;

  /** Computed **/
  get resultsheaders() {
    return _.orderBy(this.resultKeywordHeader, ['order'], ['asc']);
  }

  set contents(val: GCIContentsListRes) {}

  get contents() {
    const headers = _.map(this.resultsheaders, (v: any, index: number) => v.value );
    const pickup: any = _(contentsModule.contentsSearchInfo)
    .map((value: any, index: number) => _.pick(value, ...headers))
    .value();
    return pickup;
  }

  get totalCount() {
    return contentsModule.contentsSearchTotalCount;
  }

  get currentPage() {
    return contentsModule.contentsSearchCurrentPage;
  }

  get keyword() {
    return this.$route.query.categoryname ? this.$route.query.categoryname : this.$route.params.id;
  }
  /** Refs **/
  /** Methods **/
  private async onSelected(contents: any) {
    const token = this.$route.query.token ?? appModule.token;
    if (contents.content_id !== null) {
      const path = contentsModule.isEditMode ? `/c/${contents.category_type}/edit/${contents.content_id}` : `/c/${contents.category_type}/${contents.content_id}`;
      this.$router.push({
        path: `${path}`
      });
    }
    /*
    this.category = category;
    this.id = contents.content_id;
    contentsModule.pushIsEditMode(false);
    detailModule.pushContents(contents);
    */
  }

  private onTruncate(value: string, num: number) {
    return contentsService.truncateString(value, num);
  }
  /** Watch **/
  @Watch('options', {deep: true})
  private async readDataFromAPI() {
    appModule.startLoading();
    this.loading = true;
    const { page, itemsPerPage } = this.options;
    const pageNumber = page - 1;
    const token = this.$route.query.token ?? userModule.apiToken;
    const searchType = this.$route.query.searchtype;
    let id: any = this.$route.params.id;
    let param: any = {
      q: id,
      s: pageNumber * itemsPerPage,
      n: itemsPerPage,
      o: 'dp'
    };
    if (searchType === 'hashtag') {
      param = {
        h: id,
        s: pageNumber * itemsPerPage,
        n: itemsPerPage,
        o: 'dp'
      };
    } else if (searchType === 'search') {
    } else if (searchType === 'category') {
      id = this.$route.query.categoryname;
      param = {
        c: +this.$route.params.id,
        s: pageNumber * itemsPerPage,
        n: itemsPerPage,
        o: 'dp'
      };
    }
    await contentsModule.requestContentsSearchInfo(param)
    .catch(err => {
      this.errorPropagation(err);
    });
    this.loading = false;
    this.total = contentsModule.contentsSearchTotalCount;
    this.numberOfPages = contentsModule.contentsSearchCurrentPage;
    contentsService.setBreadcrumb(this.$route.path, 'search', null, null, null, `${id}`, `${token}`, `${searchType}`); // 現在のパンくず情報をセット
    appModule.stopLoading();
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    this.readDataFromAPI();
    /*
    appModule.startLoading();
    const token = this.$route.query.token ?? userModule.apiToken;
    const searchType = this.$route.query.searchtype;
    let id: any = this.$route.params.id;
    let param: any = {
      q: id,
      s: this.count * this.limit,
      n: this.limit,
      o: 'dp'
    };
    if (searchType === 'hashtag') {
      param = {
        h: id,
        s: this.count * this.limit,
        n: this.limit,
        o: 'dp'
      };
    } else if (searchType === 'search') {
    } else if (searchType === 'category') {
      id = this.$route.query.categoryname;
      param = {
        c: +this.$route.params.id,
        s: this.count * this.limit,
        n: this.limit,
        o: 'dp'
      };
    }

    await contentsModule.requestContentsSearchInfo(param).catch(err => {
      this.errorPropagation(err);
    });

    contentsService.setBreadcrumb(this.$route.path, 'search', null, null, null, `${id}`, `${token}`, `${searchType}`); // 現在のパンくず情報をセット
    const func = _.debounce(() => {
      appModule.stopLoading();
    }, 1000);
    func();
    */
  }

}
